module.exports = __webpack_public_path__ + "static/media/mira_old_UI.9f8a669e.png";